export { ConsoleInstrumentation } from './instrumentation';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/console/index.ts